<template>
  <div>
    <!-- <van-dialog
      v-model="show"
      title="您当前没有该身份！"
      theme="round-button"
      confirmButtonColor="#1989fa"
      :confirm-button-text="`${btnText}`"
      :before-close="onBeforeClose"
    ></van-dialog> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
      btnText: '确认(3s)',
      count: 3,
    }
  },
  created() {
    this.sendNoAuthWxMsg()
  },
  beforeDestroy() {},
  mounted() {
    // this.timer = setInterval(() => {
    //   if (this.count == 0) {
    //     clearInterval(this.timer)
    //     this.btnText = '确认'
    //     this.show = false
    //     this.closeWxBrowser()
    //     return
    //   }
    //   this.count--
    //   this.btnText = `确认(${this.count}s)`
    // }, 1000)
  },
  computed: {
    userInfo() {
      return JSON.parse(localStorage.getItem('userInfo'))
    },
  },
  methods: {
    // onBeforeClose(action, done) {
    //   done()
    //   this.closeWxBrowser()
    // },
    closeWxBrowser() {
      WeixinJSBridge.call('closeWindow')
    },
    async sendNoAuthWxMsg() {
      const res = await this.$https.sendNoAuthWxMsg({
        openId: this.userInfo.openId,
        // userName: this.userInfo.name,
        mesid: 1,
        schoolId: this.userInfo.loginSchoolId,
      })
      this.closeWxBrowser()
      // if (res.code == 200) {

      // } else {
      //   this.$dialog
      //     .alert({
      //       message: '您当前没有该身份！',
      //       theme: 'round-button',
      //       confirmButtonColor: '#1989fa',
      //     })
      //     .then(() => {
      //       // on close
      //       this.closeWxBrowser()
      //     })
      // }
    },
  },
}
</script>
